import axios from 'axios'
import { $AxE2Config } from './$AxE2Config'

export const searchAddressByZipCode = async (
  zipCode,
  successCallback = null,
  errorCallback = null
): Promise<{
  prefCode: number // 1
  prefName: string // "北海道"
  city: string // "札幌市中央区"
  street: string // "南十三条西"
  //results: Array<any>
}> => {
  //if (process.env.ZIP_SEARCH_URL !== '') {
  if ($AxE2Config.getZipSearchUrl() !== '') {
    try {
      const response = await axios.request({
        baseURL : $AxE2Config.getZipSearchUrl(),
        //baseURL: process.env.ZIP_SEARCH_URL,
        // url: '/searchAddressByZipCode',
        url: '',
        method: 'GET',
        params: { zipCode:zipCode },
      })
      console.log('searchAddressByZipCode response:', response)
      const res = response.data
      res.prefCode = response.data.prefCode
      res.prefName = response.data.prefName
      res.city = response.data.city
      res.street = response.data.street
      if (successCallback && typeof successCallback === 'function') {
        successCallback(res)
      }
      return res
    } catch (e) {
      if (errorCallback && typeof errorCallback === 'function') {
        errorCallback(e)
      } else {
        window.alert(`郵便番号 ${zipCode} から住所が見つかりませんでした。`)
      }
      throw e
    }
  }
}
// @ts-ignore
//window.searchAddressByZipCode = searchAddressByZipCode
